import { Component } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { AuthService } from 'src/app/core/services/auth.service'

@Component({
  selector: 'app-simulation-data',
  templateUrl: './simulation-data.component.html',
  standalone: false,
})
export class SimulationDataComponent {
  public Layers = Layers
  public isAccidentsLayerVisible: boolean | undefined
  public isBdvLayerVisible: boolean | undefined
  public isCSLayerVisible: boolean | undefined
  public isLVLayerVisible: boolean | undefined
  public isTLLayerVisible: boolean | undefined
  public isHRLayerVisible: boolean | undefined
  public isHSLayerVisible: boolean | undefined
  public isSWLayerVisible: boolean | undefined
  public isPRLayerVisible: boolean | undefined
  public isWWDLayerVisible: boolean | undefined
  public isIORLayerVisible: boolean | undefined
  public isALLayerVisible: boolean | undefined
  public isBLLayerVisible: boolean | undefined
  public isSVLayerVisible: boolean | undefined
  public isTJTLayerVisible: boolean | undefined
  public onDestroy: boolean | undefined = false
  public Permissions = Permissions

  constructor(
    private appState: AppStateService,
    private authService: AuthService,
  ) {
    const layers = this.appState
      .selectLayers()
      .filter((layer) => !layer.includes(Layers.SimWarning.name))
    if (layers.length > 0) {
      this.isAccidentsLayerVisible =
        layers?.some((layer) => layer === Layers.VAWarning.name) &&
        this.authService.hasPermission(Layers.VAWarning.permissions, 'any')
      this.isBdvLayerVisible =
        layers?.some((layer) => layer === Layers.BDVWarning.name) &&
        this.authService.hasPermission(Layers.BDVWarning.permissions, 'any')
      this.isCSLayerVisible =
        layers?.some((layer) => layer === Layers.CSWarning.name) &&
        this.authService.hasPermission(Layers.CSWarning.permissions, 'any')
      this.isLVLayerVisible =
        layers?.some((layer) => layer === Layers.LVWarning.name) &&
        this.authService.hasPermission(Layers.LVWarning.permissions, 'any')
      this.isTLLayerVisible =
        layers?.some((layer) => layer === Layers.TLWarning.name) &&
        this.authService.hasPermission(Layers.TLWarning.permissions, 'any')
      this.isHRLayerVisible =
        layers?.some((layer) => layer === Layers.HRWarning.name) &&
        this.authService.hasPermission(Layers.HRWarning.permissions, 'any')
      this.isHSLayerVisible =
        layers?.some((layer) => layer === Layers.HSWarning.name) &&
        this.authService.hasPermission(Layers.HSWarning.permissions, 'any')
      this.isSWLayerVisible =
        layers?.some((layer) => layer === Layers.SWWarning.name) &&
        this.authService.hasPermission(Layers.SWWarning.permissions, 'any')
      this.isPRLayerVisible =
        layers?.some((layer) => layer === Layers.PRWarning.name) &&
        this.authService.hasPermission(Layers.PRWarning.permissions, 'any')
      this.isWWDLayerVisible =
        layers?.some((layer) => layer === Layers.WWDWarning.name) &&
        this.authService.hasPermission(Layers.WWDWarning.permissions, 'any')
      this.isIORLayerVisible =
        layers?.some((layer) => layer === Layers.IORWarning.name) &&
        this.authService.hasPermission(Layers.IORWarning.permissions, 'any')
      this.isALLayerVisible =
        layers?.some((layer) => layer === Layers.ALWarning.name) &&
        this.authService.hasPermission(Layers.ALWarning.permissions, 'any')
      this.isBLLayerVisible =
        layers?.some((layer) => layer === Layers.BLWarning.name) &&
        this.authService.hasPermission(Layers.BLWarning.permissions, 'any')
      this.isSVLayerVisible =
        layers?.some((layer) => layer === Layers.SVWarning.name) &&
        this.authService.hasPermission(Layers.SVWarning.permissions, 'any')
      this.isTJTLayerVisible =
        layers?.some((layer) => layer === Layers.TJTWarning.name) &&
        this.authService.hasPermission(Layers.TJTWarning.permissions, 'any')
    } else {
      this.isAccidentsLayerVisible = this.authService.hasPermission(
        Layers.VAWarning.permissions,
        'any',
      )
      this.isBdvLayerVisible = this.authService.hasPermission(Layers.BDVWarning.permissions, 'any')
      this.isLVLayerVisible = this.authService.hasPermission(Layers.LVWarning.permissions, 'any')
      this.isTLLayerVisible = this.authService.hasPermission(Layers.TLWarning.permissions, 'any')
      this.isCSLayerVisible = this.authService.hasPermission(Layers.CSWarning.permissions, 'any')
      this.isHRLayerVisible = this.authService.hasPermission(Layers.HRWarning.permissions, 'any')
      this.isHSLayerVisible = this.authService.hasPermission(Layers.HSWarning.permissions, 'any')
      this.isSWLayerVisible = this.authService.hasPermission(Layers.SWWarning.permissions, 'any')
      this.isPRLayerVisible = this.authService.hasPermission(Layers.PRWarning.permissions, 'any')
      this.isWWDLayerVisible = this.authService.hasPermission(Layers.WWDWarning.permissions, 'any')
      this.isIORLayerVisible = this.authService.hasPermission(Layers.IORWarning.permissions, 'any')
      this.isALLayerVisible = this.authService.hasPermission(Layers.ALWarning.permissions, 'any')
      this.isBLLayerVisible = this.authService.hasPermission(Layers.BLWarning.permissions, 'any')
      this.isSVLayerVisible = this.authService.hasPermission(Layers.SVWarning.permissions, 'any')
      this.isTJTLayerVisible = this.authService.hasPermission(Layers.TJTWarning.permissions, 'any')
    }

    this.updateQueryParameters()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.VAWarning.name:
        this.isAccidentsLayerVisible = !this.isAccidentsLayerVisible
        break
      case Layers.BDVWarning.name:
        this.isBdvLayerVisible = !this.isBdvLayerVisible
        break
      case Layers.CSWarning.name:
        this.isCSLayerVisible = !this.isCSLayerVisible
        break
      case Layers.LVWarning.name:
        this.isLVLayerVisible = !this.isLVLayerVisible
        break
      case Layers.TLWarning.name:
        this.isTLLayerVisible = !this.isTLLayerVisible
        break
      case Layers.HRWarning.name:
        this.isHRLayerVisible = !this.isHRLayerVisible
        break
      case Layers.HSWarning.name:
        this.isHSLayerVisible = !this.isHSLayerVisible
        break
      case Layers.SWWarning.name:
        this.isSWLayerVisible = !this.isSWLayerVisible
        break
      case Layers.PRWarning.name:
        this.isPRLayerVisible = !this.isPRLayerVisible
        break
      case Layers.WWDWarning.name:
        this.isWWDLayerVisible = !this.isWWDLayerVisible
        break
      case Layers.IORWarning.name:
        this.isIORLayerVisible = !this.isIORLayerVisible
        break
      case Layers.ALWarning.name:
        this.isALLayerVisible = !this.isALLayerVisible
        break
      case Layers.BLWarning.name:
        this.isBLLayerVisible = !this.isBLLayerVisible
        break
      case Layers.SVWarning.name:
        this.isSVLayerVisible = !this.isSVLayerVisible
        break
      case Layers.TJTWarning.name:
        this.isTJTLayerVisible = !this.isTJTLayerVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          layer !== Layers.BDVWarning.name &&
          layer !== Layers.VAWarning.name &&
          layer !== Layers.CSWarning.name &&
          layer !== Layers.TLWarning.name &&
          layer !== Layers.LVWarning.name &&
          layer !== Layers.HRWarning.name &&
          layer !== Layers.HSWarning.name &&
          layer !== Layers.SWWarning.name &&
          layer !== Layers.PRWarning.name &&
          layer !== Layers.WWDWarning.name &&
          layer !== Layers.IORWarning.name &&
          layer !== Layers.ALWarning.name &&
          layer !== Layers.BLWarning.name &&
          layer !== Layers.SVWarning.name &&
          layer !== Layers.TJTWarning.name,
      )

    if (this.isAccidentsLayerVisible) {
      layers.push(Layers.VAWarning.name)
    }
    if (this.isBdvLayerVisible) {
      layers.push(Layers.BDVWarning.name)
    }
    if (this.isCSLayerVisible) {
      layers.push(Layers.CSWarning.name)
    }
    if (this.isLVLayerVisible) {
      layers.push(Layers.LVWarning.name)
    }
    if (this.isTLLayerVisible) {
      layers.push(Layers.TLWarning.name)
    }
    if (this.isHRLayerVisible) {
      layers.push(Layers.HRWarning.name)
    }
    if (this.isHSLayerVisible) {
      layers.push(Layers.HSWarning.name)
    }
    if (this.isSWLayerVisible) {
      layers.push(Layers.SWWarning.name)
    }
    if (this.isPRLayerVisible) {
      layers.push(Layers.PRWarning.name)
    }
    if (this.isWWDLayerVisible) {
      layers.push(Layers.WWDWarning.name)
    }
    if (this.isIORLayerVisible) {
      layers.push(Layers.IORWarning.name)
    }
    if (this.isALLayerVisible) {
      layers.push(Layers.ALWarning.name)
    }
    if (this.isBLLayerVisible) {
      layers.push(Layers.BLWarning.name)
    }
    if (this.isSVLayerVisible) {
      layers.push(Layers.SVWarning.name)
    }
    if (this.isTJTLayerVisible) {
      layers.push(Layers.TJTWarning.name)
    }
    this.appState.setState(AppPaths.Simulation, {
      layers: layers?.toString(),
    })
  }
}
